"use client";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Toaster } from "sonner";

// Você pode copiar o objeto 'theme' do seu AuthenticatedLayout.jsx
// para manter a consistência visual.
const theme = createTheme({
  palette: {
    primary: {
      main: "#FFB300",
    },
    background: {
      default: "#181714",
      paper: "#27272a",
    },
    text: {
      primary: "#ffffff",
      secondary: "#a1a1aa",
    },
  },
  // ... (copie o resto das customizações de 'components' do seu AuthenticatedLayout)
});

export default function PublicLayout({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Toaster />
      <div className="min-h-screen bg-[#1c1b19] text-white">
        <main>{children}</main>
      </div>
    </ThemeProvider>
  );
}